<template>
  <!-- 美团M站 -->
  <!-- <van-button
    style="margin: 30px;"
    color="#437fee"
    @click="clickPay()"
    :loading="loading"
    loading-text="支付中..."
  >
    美团M点击支付
  </van-button> -->
  <div class="middle">
    <h2 class="middle-top">温馨提示</h2>
    <h3 class="middle-type">请选择支付方式</h3>
    <van-radio-group v-model="checked">
      <van-cell-group>
        <van-cell :icon="require('@/assets/wx.png')" title="微信">
          <template #right-icon>
            <van-radio :name="1" checked-color="#6A67F7" />
          </template>
        </van-cell>

        <van-cell>
          <van-button
            style="text-align:center"
            text="立即支付"
            block
            round
            color="#437fee"
            loading-text="支付中..."
            :loading="loading"
            @click="clickPay"
          />
        </van-cell>
      </van-cell-group>
    </van-radio-group>
  </div>
</template>

<script>
import { getmtPay } from '@/api/api.js'
import { Toast } from 'vant'
export default {
  data() {
    return {
      loading: false,
      checked: 1
    }
  },
  methods: {
    async clickPay() {
      try {
        this.loading = true
        const { data, code, message } = await getmtPay({
          orderId: this.$route.query.thirdPayOrderId,
          payWay: 1
        })
        this.loading = false
        if (code !== 0) {
          Toast.fail(message)
          return
        }
        window.location.replace(
          data?.h5Url +
            '&redirect_url=' +
            encodeURIComponent(
              `https://test.yidianlife.com/yxl1/#/mtResult?reverseUrl=${data?.returnUrl}`
            )
        )
        console.log(data)
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.middle {
  //   background: #23305b;
  &-top {
    font-size: 18px;
    line-height: 44px;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 45%;
      width: 30px;
      height: 3px;
      background: linear-gradient(90deg, #16dafd, #5d5fef);
      border-radius: 1.5px;
    }
  }
  &-type {
    font-weight: 400;
    color: #aaafc2;
    font-size: 16px;
    text-align: center;
    padding: 12px 0 10px;
  }
  /deep/ .van-cell {
    align-items: center;
    .van-cell__left-icon {
      height: auto;
      line-height: auto;
    }
  }
}
</style>
